import { getDBIdFromGraphqlId } from "src/utils/commonFunctions";

export const getTokenAndRedirectF2 = async (role , client) => {
  console.log(client)
  try {
    const authUrl = `${process.env.REACT_APP_CORE_API_TOKEN}/auth`;

    const userString = localStorage.getItem('user');
    const userObject = userString ? JSON.parse(userString) : null;
    const userId = userObject ? userObject.username : null;
    const password = localStorage.getItem('ClientDocument');
  
    if (!userId) {
      throw new Error('User ID not found in localStorage');
    }
 const id = getDBIdFromGraphqlId( client.user?.id).toString()
    const response = await fetch(authUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId:id,
        password:client?.user?.documentNumber,
        role,
      }),
    });

    if (!response.ok) {
      throw new Error(`Authentication failed: ${response.statusText}`);
    }

   const data = await response.json();
    const token = data.token || data.access_token || data.accessToken;

    if (!token) {
      throw new Error('Token not found in response');
    }
    const urlF2 = `${process.env.REACT_APP_LINK_FORM_F2}?token=${token}`;
    window.open(urlF2, '_blank');
  } catch (error) {
    console.error('Error getting token and redirecting:', error);
    throw error;
  }
};
